// low med high
export var tresholds = {
  eyebag: [0.3, 0.6],
  eyebags: [0.3, 0.6],
  dark_circle: [0.3, 0.6],
  'dark circles': [0.3, 0.6],
  wrinkle: [0.3, 0.5],
  wrinkles: [0.3, 0.5],
  redness: [0.3, 0.6],
  hyperpigmentation: [0.3, 0.6],
  default: [0.3, 0.6],
};

export var getLevelForValue = function(type, value) {
  if (!tresholds.hasOwnProperty(type)) {
    type = 'default';
  }
  var level = 'low';
  if (value > tresholds[type][0]) {
    level = 'med';
  }
  if (value > tresholds[type][1]) {
    level = 'high';
  }
  return level;
};

export var findSkintypeFromFilters = function(filters) {
  for (const key in filters) {
    if (filters.hasOwnProperty(key)) {
      const value = filters[key];
      if (key.endsWith('_skin_ui') && value > 0) {
        return key;
      }
    }
  }
  return null;
};

export function sumMeasures(data) {
  let o = {};
  data.map(result => {
    if (Array.isArray(result.sum_measures) && result.sum_measures.length <= 0) {
      var total = 0;
      result.measurement_locations.map(loc => {
        total += loc.value;
        return true;
      });
      var avg = total / result.measurement_locations.length;
      result.sum_measures.push({ description: result.description, value: avg });
    }
    o[result.description] = result;
    return true;
  });
  return o;
}

export const inStoreIconSetup = {
  'Face shape': {
    key: 'Makeup',
    requestKey: 'face_shape_cv',
    withDescription: 'Face shape',
    icon: 'shape',
    label: 'icon_shape',
    order: 1,
    enum: {
      '1': 'Diamond',
      '2': 'Heart',
      '3': 'Long',
      '4': 'Oval',
      '5': 'Round',
      '6': 'Square',
    },
    sdkMethod: 'highlightFaceShape',
    zoom: true,
  },
  'Eye color': {
    key: 'Makeup',
    requestKey: 'eye_color_cv',
    withDescription: 'Eye color',
    icon: 'eyecolor',
    label: 'icon_eyecolor',
    order: 2,
    enum: {
      '1': 'Brown',
      '2': 'Blue',
      '3': 'Green',
    },
    sdkMethod: 'highlightEyeColor',
    zoom: true,
  },
  Undertone: {
    key: 'Makeup',
    requestKey: 'undertone_cv',
    withDescription: 'Skin undertone',
    icon: 'undertone',
    label: 'icon_undertone',
    order: 3,
    enum: { '-1': 'Cool', '0': 'Neutral', '1': 'Warm' },
    sdkMethod: 'highlightSkinUndertone',
    zoom: true,
  },
  Foundation: {
    key: 'Makeup',
    requestKey: 'skintone_color_cv',
    withDescription: 'Skin foundation RGB',
    icon: 'skintoneColor',
    label: 'icon_skintoneColor',
    order: 4,
    type: 'skintoneColor',
    sdkMethod: 'highlightSkinFoundation',
    zoom: true,
  },
  Skintone: {
    key: 'sdkMethod',
    requestKey: 'skintone',
    withDescription: '',
    icon: 'undertone',
    label: 'icon_skintone',
    order: 5,
    type: 'skintone',
    enum: {
      '1': 'Light',
      '2': 'Fair',
      '3': 'Medium',
      '4': 'Olive',
      '5': 'Brown',
      '6': 'Dark brown',
    },
    sdkMethod: 'highlightCheekArea',
    zoom: true,
  },
  'Dark circles': {
    key: 'eyes',
    requestKey: 'dark_circles_cv',
    withDescription: 'dark circles',
    icon: 'darkcircles',
    label: 'icon_darkcircles',
    order: 6,
    sdkMethod: 'highlightDarkcircles',
    zoom: true,
    range: {
      none: { min: 0, max: 0.05, color: 'gray' },
      low: { min: 0.05, max: 0.3, color: '#4cfc66' },
      medium: { min: 0.3, max: 0.6, color: '#fcd44c' },
      high: { min: 0.6, max: 1, color: '#fc4c4c' },
    },
  },
  'Wrinkles & Lines': {
    key: 'wrinkles',
    requestKey: 'wrinkles_cv',
    withDescription: 'wrinkles',
    icon: 'wrinkleslines',
    label: 'icon_wrinkleslines',
    order: 7,
    sdkMethod: 'highlightWrinkles',
    zoom: true,
    range: {
      none: { min: 0, max: 0.05, color: 'gray' },
      low: { min: 0.05, max: 0.3, color: '#4cfc66' },
      medium: { min: 0.3, max: 0.6, color: '#fcd44c' },
      high: { min: 0.6, max: 1, color: '#fc4c4c' },
    },
  },
  'Wrinkles Individually': {
    key: 'wrinkles',
    requestKey: 'wrinkles_cv',
    withDescription: 'wrinkles',
    icon: 'wrinkleslines',
    label: 'icon_wrinkleslines',
    order: 7,
    sdkMethod: 'highlightWrinklesIndividually',
    zoom: false,
    range: {
      none: { min: 0, max: 0.05, color: 'gray' },
      low: { min: 0.05, max: 0.3, color: '#4cfc66' },
      medium: { min: 0.3, max: 0.6, color: '#fcd44c' },
      high: { min: 0.6, max: 1, color: '#fc4c4c' },
    },
  },
  'Pigment Variation': {
    key: 'hyperpigmentation',
    requestKey: 'hyperpigmentation_cv',
    withDescription: 'hyperpigmentation',
    icon: 'pigmentvariation',
    label: 'icon_pigmentvariation',
    order: 8,
    sdkMethod: 'highlightHyperpigmentation',
    zoom: true,
    range: {
      none: { min: 0, max: 0.05, color: 'gray' },
      low: { min: 0.05, max: 0.3, color: '#4cfc66' },
      medium: { min: 0.3, max: 0.6, color: '#fcd44c' },
      high: { min: 0.6, max: 1, color: '#fc4c4c' },
    },
  },
  'Pigment Variation Individually': {
    key: 'hyperpigmentation',
    requestKey: 'hyperpigmentation_cv',
    withDescription: 'hyperpigmentation',
    icon: 'pigmentvariation',
    label: 'icon_pigmentvariation',
    order: 8,
    sdkMethod: 'highlightHyperpigmentationIndividually',
    zoom: false,
    range: {
      none: { min: 0, max: 0.05, color: 'gray' },
      low: { min: 0.05, max: 0.3, color: '#4cfc66' },
      medium: { min: 0.3, max: 0.6, color: '#fcd44c' },
      high: { min: 0.6, max: 1, color: '#fc4c4c' },
    },
  },
  'Eye bags': {
    key: 'eyes',
    requestKey: 'eyebags_cv',
    withDescription: 'eyebags',
    icon: 'eyebags',
    label: 'icon_eyebags',
    order: 9,
    sdkMethod: 'highlightEyebags',
    zoom: true,
    range: {
      none: { min: 0, max: 0.05, color: 'gray' },
      low: { min: 0.05, max: 0.3, color: '#4cfc66' },
      medium: { min: 0.3, max: 0.6, color: '#fcd44c' },
      high: { min: 0.6, max: 1, color: '#fc4c4c' },
    },
  },
  Redness: {
    key: 'redness',
    requestKey: 'redness_cv',
    withDescription: 'redness',
    icon: 'redness',
    label: 'icon_redness',
    order: 10,
    sdkMethod: 'highlightRedness',
    zoom: true,
    range: {
      none: { min: 0, max: 0.05, color: 'gray' },
      low: { min: 0.05, max: 0.3, color: '#4cfc66' },
      medium: { min: 0.3, max: 0.6, color: '#fcd44c' },
      high: { min: 0.6, max: 1, color: '#fc4c4c' },
    },
  },
  Texture: {
    key: 'texture',
    requestKey: 'texture_cv',
    withDescription: 'texture',
    icon: 'texture',
    label: 'icon_texture',
    order: 11,
    sdkMethod: 'highlightTexture',
    zoom: true,
    range: {
      none: { min: 0, max: 0.05, color: 'gray' },
      low: { min: 0.05, max: 0.3, color: '#4cfc66' },
      medium: { min: 0.3, max: 0.6, color: '#fcd44c' },
      high: { min: 0.6, max: 1, color: '#fc4c4c' },
    },
  },
  Radiance: {
    key: 'smoothness',
    requestKey: 'smoothness_cv',
    withDescription: 'smoothness',
    icon: 'radiance',
    label: 'icon_radiance',
    order: 12,
    sdkMethod: 'highlightSmoothness',
    zoom: true,
    range: {
      none: { min: 0, max: 0.05, color: 'gray' },
      low: { min: 0.05, max: 0.3, color: '#4cfc66' },
      medium: { min: 0.3, max: 0.6, color: '#fcd44c' },
      high: { min: 0.6, max: 1, color: '#fc4c4c' },
    },
  },
  'Skin Shine': {
    key: 'Skin shine',
    requestKey: 'skin_shine_cv',
    withDescription: 'Skin shine',
    icon: 'skinShine',
    label: 'icon_skin_shine',
    order: 13,
    sdkMethod: 'highlightSkinShine',
    zoom: false,
    range: {
      none: { min: 0, max: 0.05, color: 'gray' },
      low: { min: 0.05, max: 0.3, color: '#4cfc66' },
      medium: { min: 0.3, max: 0.6, color: '#fcd44c' },
      high: { min: 0.6, max: 1, color: '#fc4c4c' },
    },
  },
  Acne: {
    key: 'acne',
    requestKey: 'acne_cv',
    withDescription: 'acne',
    icon: 'acne',
    label: 'icon_acne',
    order: 14,
    sdkMethod: 'highlightAcneIndividually',
    zoom: false,
    range: {
      none: { min: 0, max: 0.05, color: 'gray' },
      low: { min: 0.05, max: 0.3, color: '#4cfc66' },
      medium: { min: 0.3, max: 0.6, color: '#fcd44c' },
      high: { min: 0.6, max: 1, color: '#fc4c4c' },
    },
  },
};

export function rgbToHex(rgb) {
  if (!rgb || rgb.length <= 0) {
    return null;
  }
  let hexValue = '#';
  for (const rgbValue of rgb) {
    hexValue += rgbValueToHex(rgbValue).toUpperCase();
  }
  return hexValue;
}

function rgbValueToHex(rgb) {
  let hex = Number(rgb).toString(16);
  if (hex.length < 2) {
    hex = '0' + hex;
  }
  return hex;
}

function hexToRgb({ hex }) {
  const bigint = parseInt(hex, 16);
  const r = (bigint >> 16) & 255;
  const g = (bigint >> 8) & 255;
  const b = bigint & 255;
  return [r, g, b];
}

export function converProductColorToRGB({ product }) {
  const colorExpression = 'color_hex_';
  let hex = product.filter_match.find(filterMatch => filterMatch.indexOf(colorExpression) === 0);
  if (!hex) {
    return null;
  }
  hex = hex.replace(colorExpression, '');
  hex = hex.replace('#', '');
  hex = hex.replace('0x', '');
  return hexToRgb({ hex });
}

const sdkFinishReference = {
  matte: 'matte',
  sheer: 'gloss',
  satin: 'natural',
};
export function getFinishFromProduct({ product }) {
  const finishExpression = 'lipstick_finish_matte_ui';
  let finish = product.filter_match.find(filterMatch => filterMatch.indexOf(finishExpression) === 0);
  if (!finish) {
    return null;
  }
  finish = finish.replace('lipstick_finish_', '');
  finish = finish.replace('_ui', '');
  return sdkFinishReference[finish] || 'natural';
}

const coverageValues = {
  AR: {
    full: 1,
    medium: 0.8,
    light: 0.6,
  },
  liveAR: {
    full: 1,
    medium: 0.8,
    light: 0.6,
  },
};

export function getCoverageFromProduct({ product, filters, mode }) {
  const coverageString = 'coverage_ui';
  let coverage = 'full'; //default value
  const productCoverage = product.filter_match.find(filterMatch => filterMatch.indexOf(coverageString) >= 0);
  if (productCoverage) {
    //we have found coverage info for product
    coverage = productCoverage.replace(`_${coverageString}`, '');
  } else {
    //No product information . We need to find if user has set prefered foundation coverage in questions
    const filterCoverage = Object.keys(filters)
      .filter(filterKey => filterKey.indexOf(coverageString) >= 0)
      .find(filterKey => filters[filterKey] === 1);
    if (filterCoverage) {
      coverage = filterCoverage.replace(`_${coverageString}`, '');
    }
  }
  return coverageValues[mode][coverage] || 0.8;
}

export function isObject(item) {
  return item && typeof item === 'object' && !Array.isArray(item);
}

export function mergeDeep(target, ...sources) {
  if (!sources.length) return target;
  const source = sources.shift();

  if (isObject(target) && isObject(source)) {
    for (const key in source) {
      if (isObject(source[key])) {
        if (!target[key]) Object.assign(target, { [key]: {} });
        mergeDeep(target[key], source[key]);
      } else {
        Object.assign(target, { [key]: source[key] });
      }
    }
  }

  return mergeDeep(target, ...sources);
}

export const camelize = str => {
  return str.replace(/(?:^\w|[A-Z]|\b\w|\s+)/g, function(match, index) {
    if (+match === 0) return ''; // or if (/\s+/.test(match)) for white spaces
    return index === 0 ? match.toLowerCase() : match.toUpperCase();
  });
};



// WEBPACK FOOTER //
// ./src/utils.js